import { Component } from '@angular/core';
import { MigrationsNumbersPollingContext } from '../services/migrations-numbers-polling-context.service';
import { MigrationsNumberContext } from '../services/migrations-numbers-context.service';
import { RingCentralCallQueuesContext } from './ring-central-call-queues/ring-central-call-queues.context';
import { RingCentralCallQueuesPollingContext } from './ring-central-call-queues/ring-central-call-queues-polling.context';
import { RingCentralAutoAttendantsPollingContext } from '../services/ring-central/ring-central-auto-attendants-polling.context';
import { RingCentralAutoAttendantsContext } from '../services/ring-central/ring-central-auto-attendants.context';

@Component({
  selector: 'ziro-migrations-ring-central',
  templateUrl: './migrations-ring-central.component.html',
  standalone: false,
  providers: [
    MigrationsNumbersPollingContext,
    MigrationsNumberContext,
    RingCentralCallQueuesPollingContext,
    RingCentralCallQueuesContext,
    RingCentralAutoAttendantsPollingContext,
    RingCentralAutoAttendantsContext,
  ],
})
export class MigrationsRingCentralComponent {}
